import { useState, useEffect } from "react";
import "./ResponseContentNumber.css";
import { Question } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { NumberResponse } from "../config/responseSettings";
import config from "environment";
import { ResponseErrors } from "./responseErrors";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentNumberProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentNumber = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentNumberProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [number, setNumber] = useState<number | null>(null);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);

        const num = JSON.parse(responseValues).number;
        if (num) {
            setNumber(num);
        } else {
            setNumber(null);
        }
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const metRequirements = (theNumber: number | null) : "ok" | "required" | "minError" | "maxError" => {
        if (theNumber === null && !question.required) return "ok";
        if (theNumber === null && question.required) return "required";

        const settings = JSON.parse(question.settings || "{}");

        if (settings && theNumber !== null) {
            if (settings.minNumOn && theNumber < settings.minNum) return "minError";
            if (settings.maxNumOn && theNumber > settings.maxNum) return "maxError";

            return "ok";
        }

        return "ok";
    }

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {

        const metReqs = metRequirements(number);

        const settings = JSON.parse(question.settings || "{}");

        if (metReqs === "required") {
            setError(ResponseErrors.required);
            return;
        }
    
        if (metReqs === "minError") {
            setError(`${ResponseErrors.minNum} ${settings.minNum}.`);
            return;
        }

        if (metReqs === "maxError") {
            setError(`${ResponseErrors.maxNum} ${settings.maxNum}.`);
            return;
        }

        const newResponseValues: string = JSON.stringify({
            number
        } as NumberResponse);

        console.log("[ResponseContentNumber] newResponseValues: ", newResponseValues);

        onSubmit(newResponseValues);
    }

    const handleKeyDown = (e: any) => {
        
        if (e.key === "Enter") {
            handleSubmit();
            return;
        }

        setError(ResponseErrors.none)
    }

    const handlePaste = (e: any) => {
        const theNumber = parseFloat(e.clipboardData.getData('text'));

        if (isNaN(theNumber)) {
            setError(ResponseErrors.validNumber);
            return;
        }

        const metReqs = metRequirements(theNumber);

        const settings = JSON.parse(question.settings || "{}");
    
        if (metReqs === "minError") {
            setError(`${ResponseErrors.minNum} ${settings.minNum}.`);
            return;
        }

        if (metReqs === "maxError") {
            setError(`${ResponseErrors.maxNum} ${settings.maxNum}.`);
            return;
        }

        if (!isNumber(e.target.value)) {
            setError(ResponseErrors.validNumber);
            return;
        }

        setNumber(+e.target.value);
    }

    function isNumber(str: string) {
        const test = /^\d+$/;
        return(test.test(str)) 
    }

    const handleChange = (e: any) => {

        if (e.target.value === "") {
            setNumber(null);
            setError(ResponseErrors.none)
            return;
        }

        if (!isNumber(e.target.value)) {
            setError(ResponseErrors.validNumber);
            return;
        }

        setNumber(+e.target.value);
    }

    const requirementsMet = metRequirements(number) === "ok";
    
    // console.log("[ResponseContentNumber] question: ", question);
    // console.log("[ResponseContentNumber] values: ", responseValues);
    // console.log("[ResponseContentNumber] text: ", text);


    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
                        
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div style={{marginTop: "24px"}} className="response-content-text">
                <input 
                    type="text"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    value={number ? number : ""}
                    placeholder="Enter a number.."
                    data-testid="response-content-value"
                    autoFocus={true}
                />
            </div>    
            
            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                allowEnter={true}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}